import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// ภาษาอังกฤษ
import en from './locales/en.json';
// ภาษาไทย
import th from './locales/th.json';
// ภาษาจีน
import zh from './locales/zh.json';
// ภาษารัสเซีย
import ru from './locales/ru.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      th: { translation: th },
      zh: { translation: zh },
      ru: { translation: ru },
    },
    lng: 'en', // ภาษาเริ่มต้น
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
